import React, { useState, useEffect } from "react";
import { axiosV2 } from "../../../utils/BasicAuthAPI";
import moment from "moment";
import "../audit.css";
import {
  Spin,
  Modal,
  Form,
  Input,
  Select,
  DatePicker,
  Button,
  message,
  Typography,
  Col,
  Row,
  Tree,
  Switch,
  Table,
  Pagination,
} from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import queryString from "query-string";
import { useParams, useLocation } from "react-router-dom";
import { DownSquareOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import AddTaskModal from "./AddTaskModal";
import liracrypt from "../../Liracrypt/liracrypt";
import SessionError from "../../ApiErrorComp/SessionError";
import ApiErrorComp from "../../ApiErrorComp/ApiErrorComp";

const AuditReportViewPage = (props) => {
  const antIcon = <LoadingOutlined style={{ fontSize: 80 }} spin />;
  const [ClauseData, setClauseData] = useState({ loaded: false, data: null });
  const [addTaskVisible, setAddTaskVisible] = useState(false);
  const [form] = Form.useForm();
  const [loginError, setLoginError] = useState(false);

  const [state, setState] = useState({
    visible: false,
    disabledBtn: false,
  });
  // let location = useLocation();
  // const params = queryString.parse(location.search);
  let { auditId } = useParams();

  const onFinish = (values) => {
    setState({ ...state, disabledBtn: true });
    let postData = { ...ClauseData.data, ...values };
    
    liracrypt
      .patch("/audit/clausereport", postData)
      .then((res, req) => {
        let data = res.data;
        const msg = data["message"] ? data["message"] : "Successfully Added!";
        message.success(msg, 4);
        setState({ ...state, disabledBtn: false });
        props.sendBackData(postData);
      })
      .catch(function (error) {
        message.error("ERROR: Unable to add!!", 2);
        console.log("Error****: fetch save", error);
        setState({ ...state, disabledBtn: false });
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };
  const modelCloseHandler = (data) => {
    let clause = { ...ClauseData };
    clause.data.Tasks.push(data);
    setAddTaskVisible(false);
    setClauseData(clause);
  };
  const fetchClauseData = () => {
    liracrypt
      .get("/audit/clausereport", {
        _id: props.clauseObj._id,
        typ: props.clauseObj.typ,
        subTyp: props.clauseObj.subTyp,
      })
      .then((res, req) => {
        let data = res.data;
        
        setClauseData({ loaded: true, data: data.data });
        form.setFieldsValue({
          REM: data.data["rEM"],
          Evid: data.data["evid"],
          Compliance: data.data["compliance"],
          RespText: data.data["respText"],
          ST_Resp: data.data["st_Resp"],
          CntrMeasText: data.data["cntrMeastext"],
          ST_CntrMeas: data.data["st_CntrMeas"],
          ST_Aud: data.data["st_Aud"],
        });
      })
      .catch(function (error) {
        console.log("Error****: fetch clause data", error);
        if (error.response !== undefined) {
          if (error.response.status !== 401) {
            // ApiErrorComp(error.response.status);
          } else {
            setLoginError(true);
          }
        }
      });
  };

  const columns = [
    {
      title: "Task",
      dataIndex: "task",
      key: "task",
    },
    {
      title: "Resp Name",
      dataIndex: "respName",
      key: "respName",
    },
    {
      title: "Target Date",
      dataIndex: "tgtDt",
      key: "tgtDt",
    },
    {
      title: "Task Status",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "Approval Status",
      dataIndex: "stByResp",
      key: "stByResp",
    },
  ];

  useEffect(() => {
    if (!ClauseData.loaded) {
      fetchClauseData();
    }
  }, [ClauseData.loaded]);

  return (
    <>
      <SessionError visible={loginError} />
      <div className="AuditSection ClauseDetail">
        <div>
          {ClauseData.loaded ? (
            <>
              <Row justify="space-around" gutter={24} align="middle">
                <Col span={24}>
                  <h4 className={"title textCenter"}>Clause Report</h4>
                </Col>
                <Col span={24} style={{ paddingBottom: "15px" }}>
                  <Row
                    justify="space-around"
                    gutter={24}
                    align="middle"
                    style={{
                      backgroundColor: "#28293d",
                      margin: "0px",
                      padding: "10px",
                    }}
                  >
                    <Col span={16} style={{ paddingBottom: "15px" }}>
                      <Row justify="space-around" gutter={24}>
                        <Col span={12}>
                          <div className={"reportLabel"}>
                            <span>Audit Type</span>
                          </div>
                        </Col>
                        <Col span={12}>
                          <Row gutter={24}>
                            <Col span={24}>
                              <div>{ClauseData.data["TYP"]}</div>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <div className={"reportLabel"}>
                            <span>Clause No</span>
                          </div>{" "}
                        </Col>
                        <Col span={12}>
                          <Row gutter={24} align="middle">
                            <Col span={24}>
                              <div>{ClauseData.data["ClauseID"]}</div>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <div className={"reportLabel"}>
                            <span>Clause</span>
                          </div>{" "}
                        </Col>
                        <Col span={12}>
                          <Row gutter={24} align="middle">
                            <Col span={24}>
                              <div>{ClauseData.data["PrimClause"]}</div>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <div className={"reportLabel"}>
                            <span></span>
                          </div>{" "}
                        </Col>
                        <Col span={12}>
                          <Row gutter={24} align="middle">
                            <Col span={24}>
                              <div>{ClauseData.data["SecClause"]}</div>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <div className={"reportLabel"}>
                            <span></span>
                          </div>{" "}
                        </Col>
                        <Col span={12}>
                          <Row gutter={24} align="middle">
                            <Col span={24}>
                              <div>{ClauseData.data["Clause"]}</div>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <div className={"reportLabel"}>
                            <span></span>
                          </div>{" "}
                        </Col>
                        <Col span={12}>
                          <Row gutter={24} align="middle">
                            <Col span={24}>
                              <div>{ClauseData.data["Txt1"]} </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <div className={"reportLabel"}>
                            <span></span>
                          </div>{" "}
                        </Col>
                        <Col span={12}>
                          <Row gutter={24} align="middle">
                            <Col span={24}>
                              <div>{ClauseData.data["Txt2"]} </div>
                            </Col>
                          </Row>
                        </Col>
                        <Col span={12}>
                          <div className={"reportLabel"}>
                            <span></span>
                          </div>{" "}
                        </Col>
                        <Col span={12}>
                          <Row gutter={24} align="middle">
                            <Col span={24}>
                              <div>{ClauseData.data["Txt3"]} </div>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>

                    <Col span={8} style={{}}>
                      <Row>
                        <Col span={24}>
                          {ClauseData.data["ImgID"] ? (
                            <div style={{ textAlign: "center" }}>
                              <i
                                style={{ fontSize: "80px" }}
                                className="fa fa-picture-o"
                              ></i>
                            </div>
                          ) : (
                            <div style={{ textAlign: "center" }}>
                              <img
                                width="100px"
                                src={require('../../../assets/static/noImg.jpeg')}
                                alt="No Image Available"
                              />
                            </div>
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                </Col>

                <Col span={24}>
                  <div className="ThemeForm">
                    <Form
                      form={form}
                      name="evntForm"
                      labelCol={{ span: 10 }}
                      wrapperCol={{ span: 14 }}
                      layout="horizontal"
                      colon={false}
                      onFinish={onFinish}
                      size="large"
                    >
                      <Row gutter={24} justify="space-around" align="middle">
                        <Col span={24}>
                          <Form.Item
                            labelCol
                            name="REM"
                            label="Observation"
                            rules={[
                              {
                                required: true,
                                message: "Please input Observation",
                              },
                            ]}
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 19 }}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item
                            name="Evid"
                            label="Evidence"
                            rules={[
                              {
                                required: true,
                                message: "Please input Evidence",
                              },
                            ]}
                            labelCol={{ span: 5 }}
                            wrapperCol={{ span: 19 }}
                          >
                            <Input />
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="Compliance"
                            label="Compliance"
                            placeholder="Select a Compliance"
                            rules={[{ required: true }]}
                          >
                            <Select
                              placeholder="Please select a Compliance"
                              optionLabelProp="label"
                            >
                              <Select.Option
                                key={"status_O"}
                                value="O"
                                label="Open"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#e74c3c",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Open
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_C"}
                                value="C"
                                label="Close"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#2ecc71",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Close
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_H"}
                                value="H"
                                label="Hold"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#3498db",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Hold
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_X"}
                                value="X"
                                label="Cancelled"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#ecf0f1",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Cancelled
                                </div>
                              </Select.Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            name="RespText"
                            label="Auditee Response"
                            rules={[
                              {
                                required: true,
                                message: "Please input Observation",
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item
                            name="CntrMeasText"
                            label="Counter Measure Proposed"
                            rules={[
                              {
                                required: true,
                                message: "Please input CntrMeasText",
                              },
                            ]}
                          >
                            <Input />
                          </Form.Item>
                          <Form.Item
                            name="ST_Aud"
                            label="Clause Status"
                            placeholder="Select a Clause Status"
                            rules={[{ required: true }]}
                          >
                            <Select
                              placeholder="Please select a Clause Status"
                              optionLabelProp="label"
                            >
                              <Select.Option
                                key={"status_O"}
                                value="O"
                                label="Open"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#e74c3c",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Open
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_C"}
                                value="C"
                                label="Close"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#2ecc71",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Close
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_H"}
                                value="H"
                                label="Hold"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#3498db",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Hold
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_X"}
                                value="X"
                                label="Cancelled"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#ecf0f1",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Cancelled
                                </div>
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={12}>
                          <Form.Item
                            name="ST_Resp"
                            label="Auditee Response Stat"
                            placeholder="Select a Auditee Response Stat"
                            rules={[{ required: true }]}
                          >
                            <Select
                              placeholder="Please select a Auditee Response Stat"
                              optionLabelProp="label"
                            >
                              <Select.Option
                                key={"status_O"}
                                value="O"
                                label="Open"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#e74c3c",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Open
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_C"}
                                value="C"
                                label="Close"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#2ecc71",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Close
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_H"}
                                value="H"
                                label="Hold"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#3498db",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Hold
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_X"}
                                value="X"
                                label="Cancelled"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#ecf0f1",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Cancelled
                                </div>
                              </Select.Option>
                            </Select>
                          </Form.Item>

                          <Form.Item
                            name="ST_CntrMeas"
                            label="Countermeasures Status"
                            placeholder="Select a Countermeasures Status"
                            rules={[{ required: true }]}
                          >
                            <Select
                              placeholder="Please select a Countermeasures Status"
                              optionLabelProp="label"
                            >
                              <Select.Option
                                key={"status_O"}
                                value="O"
                                label="Open"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#e74c3c",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Open
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_C"}
                                value="C"
                                label="Close"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#2ecc71",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Close
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_H"}
                                value="H"
                                label="Hold"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#3498db",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Hold
                                </div>
                              </Select.Option>
                              <Select.Option
                                key={"status_X"}
                                value="X"
                                label="Cancelled"
                              >
                                <div
                                  style={{
                                    borderLeft: "5px solid",
                                    borderColor: "#ecf0f1",
                                    paddingLeft: "10px",
                                  }}
                                >
                                  Cancelled
                                </div>
                              </Select.Option>
                            </Select>
                          </Form.Item>
                        </Col>
                        <Col span={24}>
                          <Table
                            className="ThemeTable"
                            columns={columns}
                            dataSource={ClauseData.data.Tasks}
                            size="small"
                            title={() => (
                              <Row
                                span={24}
                                justify="space-between"
                                align="middle"
                              >
                                <Col
                                  span={12}
                                  style={{
                                    fontSize: "16px",
                                    fontWeight: "bold",
                                  }}
                                >
                                  Tasks
                                </Col>
                                <Col span={12}>
                                  <div style={{ textAlign: "right" }}>
                                    <Button
                                      style={{ textAlign: "center" }}
                                      type="primary"
                                      htmlType="button"
                                      size={"default"}
                                      onClick={() => setAddTaskVisible(true)}
                                    >
                                      {"Add Task"}
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                            )}
                            pagination={
                              ClauseData.data.Tasks.length <= 10 ? (
                                false
                              ) : (
                                <Pagination />
                              )
                            }
                          />
                        </Col>

                        <div
                          className={"usermanagement textCenter"}
                          style={{ marginTop: "30px" }}
                        >
                          <Button
                            style={{ textAlign: "center" }}
                            type="primary"
                            htmlType="submit"
                            className="login-form-button gx-mt-1 bigBtn"
                            disabled={state.disabledBtn}
                          >
                            {"Submit"}
                          </Button>
                        </div>
                      </Row>
                    </Form>
                  </div>
                </Col>
              </Row>

              <AddTaskModal
                visible={addTaskVisible}
                modelCloseHandler={modelCloseHandler}
                ClauseData={ClauseData}
              />
            </>
          ) : (
            <div className="Loading">
              <Spin indicator={antIcon} tip="Loading..." />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default AuditReportViewPage;
